<template>
  <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 w-full">
    <h2 class="text-base font-medium text-gray-700 mb-4">Avancement des projets</h2>
    <VueApexCharts type="bar" height="300" :options="chartOptions" :series="series" />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";

// ✅ Series et options
const series = ref([{ name: "Avancement projets", data: [] }]);
const chartOptions = ref({
  chart: {
    toolbar: { show: false },
    animations: { enabled: true, easing: "easeinout", speed: 800 },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "50%",
      borderRadius: 10, // 🔹 barres arrondies en haut
      startingShape: "rounded",
      endingShape: "rounded",
    },
  },
  xaxis: {
    categories: [],
    labels: { rotate: -45, style: { fontSize: "12px" } },
  },
  yaxis: {
    min: 0,
    max: 100,
    labels: { formatter: (value) => `${value}%` },
  },
  colors: ["#3b82f6"], // 🔹 Bleu moderne
  dataLabels: { enabled: false, formatter: (val) => `${val}%`, style: { colors: ["#fff"] } },
  fill: {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 0.5,
      gradientToColors: ["#60a5fa"],
      inverseColors: false,
      opacityFrom: 0.9,
      opacityTo: 0.8,
      stops: [0, 100],
    },
  },
  tooltip: { y: { formatter: (val) => `${val}%` } },
  grid: { borderColor: "#f3f4f6", row: { colors: ["transparent"], opacity: 0.5 } },
});

// ✅ Fonction pour récupérer les projets
const fetchProjets = async () => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/dashboard/projets", {
      headers: { Authorization: `Bearer ${token}` },
    });

    const projets = res.data.projets;

    // 🔹 Mise à jour réactive des catégories pour ApexCharts
    chartOptions.value = {
      ...chartOptions.value,
      xaxis: {
        ...chartOptions.value.xaxis,
        categories: projets.map(p => String(p.nomProjet || p.nom || `Projet ${p.id.slice(-4)}`))
      }
    };

    // 🔹 Mise à jour des données
    series.value = [
      { name: "Avancement projets", data: projets.map(p => p.avancement) }
    ];

    console.log("Projets chargés pour le graphique :", projets);
  } catch (err) {
    console.error("Erreur récupération projets :", err);
  }
};

onMounted(fetchProjets);
</script>
